export function serializeSearchParams(params) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(item => query.append(key, item));
    } else {
      query.append(key, value);
    }
  });

  return query.toString();
}
